/**
 * MALA — One-time first-card image hint on collection / search.
 *
 * 5 seconds after page load, the first product card on the grid advances
 * its image once — a subtle hint that more images exist. After that, no
 * further cycling happens.
 *
 * Honors prefers-reduced-motion. Skips if the card has only 1 image.
 */
(() => {
  const DELAY_MS = 5000;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function fire() {
    const slideshow = document.querySelector(
      '.product-grid .card-gallery slideshow-component, .main-collection-grid .card-gallery slideshow-component'
    );
    if (!slideshow || typeof slideshow.next !== 'function') return;
    const slideCount = slideshow.querySelectorAll('[slide-id], slideshow-slide, .product-media-container').length;
    if (slideCount < 2) return;
    try { slideshow.next(); } catch (_) {}
  }

  function start() {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('slideshow-component').then(() => {
        window.setTimeout(fire, DELAY_MS);
      });
    } else {
      window.setTimeout(fire, DELAY_MS);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
